import React from 'react';

const LoadingRow: React.FC = () => {
  return (
    <tr>
      <td> </td>
      <td> </td>
      <td>
        <aha-loading-row
          class='py-1'
          column-widths='50%'
          style={{ '--aha-loading-row--vertical-padding': 0 }}
        />
      </td>
      <td>
        <aha-loading-row
          class='py-1'
          column-widths='75%'
          style={{ '--aha-loading-row--vertical-padding': 0 }}
        />
      </td>
      <td>
        <aha-loading-row
          class='py-1'
          column-widths='50%'
          style={{ '--aha-loading-row--vertical-padding': 0 }}
        />
      </td>
      <td style={{ textAlign: 'right' }}>
        <aha-loading-row
          class='py-1'
          column-widths='50%'
          style={{ '--aha-loading-row--vertical-padding': 0 }}
        />
      </td>
    </tr>
  );
};

export default LoadingRow;
